<template>
  <ModalBase :show-modal="isOnboardingOpen" @close-modal="close" narrow auto-h class="company-modal-onboarding">
    <template v-slot:maincontent>
      <div class="no-brands-wrap">
        <AnimationItem class="anim-company" :animation="{ animationData: companyAnimation.default }" :key="'anim_success'" />
        <h3>Welcome to brands</h3>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut a egestas sapien, vitae vestibulum metus. In non lacus tempor, venenatis libero vel:</p>
        <ul class="brand-steps">
          <li>Donec congue, nunc in finibus sollicitudin</li>
          <li>Integer posuere purus erat</li>
          <li>Sed vehicula massa lacinia eu</li>
        </ul>
        <p>
          Nullam vel mauris metus. Nullam diam lectus, convallis eu ornare sed, go ahead and 
          <GekkoButton
            @click="addBrand()"
            :text="$gettext('create your first trade name')"
            variant="link p-0"
          />
        </p>
      </div>
    </template>
    <template v-slot:actions>
      <div class="w-100 text-center">
        <GekkoButton 
          @click="dismiss()"
          :text="$gettext('Dismiss')"
          variant="link"
          size="sm"
          class="p-0"
        />
      </div>
    </template>
  </ModalBase>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import ModalBase from "@/components/base_components/ModalBase";
import GekkoButton from "@/components/GekkoButton";

import AnimationItem from '@/components/dashboard/ui/AnimationItem.vue'
import * as companyAnimation from '@/css/animations/company.json';

export default {
  name: 'BrandsOnboardingModal',
  components: {
    ModalBase,
    GekkoButton,
    AnimationItem
  },
  data () {
    return {
      companyAnimation: companyAnimation,
    }
  },
  computed: {
    ...mapGetters({
      isOnboardingOpen: "onboarding/isOnboardingOpen",
    }),
  },
  created () {
    this.checkOnboarding('gekko_onboarding_web_brands')
  },
  methods: {
    ...mapActions({
      checkOnboarding: "onboarding/checkOnboarding",
      dismissOnboarding: "onboarding/dismissOnboarding",
      closeOnboarding: "onboarding/closeOnboarding"
    }),
    close () {
      this.dismissOnboarding()
      // this.closeOnboarding()
      document.body.classList.remove('modal-on')
    },
    dismiss () {
      this.dismissOnboarding()
      document.body.classList.remove('modal-on')
    },
    addBrand () {
      this.$emit('add-brand')
      this.close()
    }
  },
}
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
  .no-brands-wrap {
    width: 100%;
    margin: 0 auto;
    max-width: 650px;
    font-size: 1rem;
    padding: 1rem;
    .anim-company {
      width: 75%;
    }
  }
  .brand-steps {
    list-style: none;
    padding: 1rem 2rem;
    counter-reset: brand-counter;
    padding-left: 4rem;
    li {
      font-size: 15px; 
      margin: 0 0 1rem 0;
      counter-increment: brand-counter;
      position: relative;
      .iban {
        white-space: nowrap;
        color: $colorBrand;
      }
      &:before {
        content: counter(brand-counter);
        color: white;
        position: absolute;
        --size: 25px;
        left: calc(-1 * var(--size) - 10px);
        line-height: var(--size);
        width: var(--size);
        height: var(--size);
        top: 0;
        background: $colorBrand;
        border-radius: 50%;
        text-align: center;
      }
    }
  }
</style>